/**
 * Brands Section - Smooth Scroll Navigation
 * Handles click events on alphabet navigation to scroll to brand sections
 */

(function () {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandsNavigation);
  } else {
    initBrandsNavigation();
  }

  function initBrandsNavigation() {
    const alphabetLinks = document.querySelectorAll('.brands-alphabet-link--active');

    if (!alphabetLinks.length) {
      return;
    }

    // Add click event listeners to all active alphabet links
    alphabetLinks.forEach(function (link) {
      link.addEventListener('click', handleAlphabetClick);
    });
  }

  /**
   * Handle alphabet link click
   * @param {Event} event - Click event
   */
  function handleAlphabetClick(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const targetId = link.getAttribute('href');

    if (!targetId) {
      return;
    }

    const targetElement = document.querySelector(targetId);

    if (!targetElement) {
      return;
    }

    // Smooth scroll to target element
    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });

    // Update URL hash without jumping
    if (history.pushState) {
      history.pushState(null, null, targetId);
    } else {
      // Fallback for older browsers
      window.location.hash = targetId;
    }

    // Optional: Update active state of alphabet links
    updateActiveLink(link);
  }

  /**
   * Update active state of alphabet navigation
   * @param {HTMLElement} activeLink - The clicked link
   */
  function updateActiveLink(activeLink) {
    const allLinks = document.querySelectorAll('.brands-alphabet-link--active');

    allLinks.forEach(function (link) {
      link.classList.remove('brands-alphabet-current');
    });

    activeLink.classList.add('brands-alphabet-current');
  }

  // Handle deep linking - scroll to hash on page load
  function handleInitialHash() {
    if (window.location.hash) {
      const targetId = window.location.hash;
      const targetElement = document.querySelector(targetId);

      if (targetElement && targetElement.classList.contains('brands-letter-group')) {
        // Small delay to ensure page is fully rendered
        setTimeout(function () {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }, 100);
      }
    }
  }

  // Call on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }
})();
